import { render, staticRenderFns } from "./confirmedEventDetail.vue?vue&type=template&id=2c29f612"
import script from "./confirmedEventDetail.vue?vue&type=script&lang=js"
export * from "./confirmedEventDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports